import { CategoryModel } from "models";
import React from "react";

type PROPS = {
  topLabel: string;
  data: CategoryModel[];
  onUpdate: (_: CategoryModel[]) => void;
  disabled?: boolean;
};

const CategoryBreadcrumb: React.FC<PROPS> = (props) => {
  const data = props.data;

  return (
    <div className="m-2 p-2 flex items-center border-y">
      <button
        className="font-bold text-2xl disabled:pointer-events-none"
        onClick={() => {
          props.onUpdate([]);
        }}
        disabled={props.data.length === 0 || props.disabled}
      >
        <div className="p-2 rounded-lg hover:bg-slate-200">
          {props.topLabel}
        </div>
      </button>
      {data &&
        data.map((item, index) => (
          <div key={index} className="font-bold text-2xl flex items-center">
            <div className="mx-4">&gt;</div>
            <button
              className="font-bold text-2xl disabled:pointer-events-none"
              onClick={() => {
                const idx = props.data.indexOf(item);
                props.onUpdate(props.data.slice(0, idx + 1));
              }}
              disabled={props.data.length - 1 === index || props.disabled}
            >
              <div className="p-2 rounded-lg hover:bg-slate-200">
                {item.name}一覧
              </div>
            </button>
          </div>
        ))}
    </div>
  );
};

export default CategoryBreadcrumb;
